import React from 'react';

import { Box, IconButton } from '@mui/material';
import clsx from 'clsx';
import { useBreakpoints } from 'hooks';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getAIAssistantReadinessPercent } from 'store/useBusinessToolStore/selectors';

import { ReactComponent as AIIcon } from 'assets/icons/AIIcon.svg';
import { ReactComponent as AIIconDefault } from 'assets/icons/AIIconDefault.svg';

import { TooltipComponent } from 'components/_basic/TooltipComponent';

import { IAIIconButtonProps } from './types';

import styles from './AIIconButton.module.scss';

export const AIIconButton: React.FC<IAIIconButtonProps> = ({ disabled, onClick, isUpgradeNeeded }) => {
  const { isMobile } = useBreakpoints();
  const Icon = disabled ? AIIconDefault : AIIcon;
  const AIAssistantReadinessPercent = useBusinessToolStore(getAIAssistantReadinessPercent);

  const tooltipText = isUpgradeNeeded ? 'Upgrade your plan to use this feature' : 'Apply AI Generation to this chapter';
  const isTooltipHidden =
    (AIAssistantReadinessPercent < 100 && isMobile) ||
    (AIAssistantReadinessPercent >= 100 && tooltipText === 'Apply AI Generation to this chapter') ||
    (isMobile && !isUpgradeNeeded);

  return (
    <TooltipComponent
      title={tooltipText}
      isTooltipHidden={isTooltipHidden}
      variant="l"
      placement="top-end"
      trigger={isMobile ? 'click' : 'hover'}
      leaveDelay={isMobile ? 2500 : 200}
    >
      <Box className={styles.iconButtonContainer}>
        <IconButton
          className={clsx(styles.iconButton, { [styles.disabled]: disabled })}
          disabled={disabled}
          onClick={onClick}
        >
          <Icon className={styles.icon} />
        </IconButton>
      </Box>
    </TooltipComponent>
  );
};
